import React, { Component } from "react";
import PropTypes from "prop-types";

// Import components
import Widget from "./Widget";
import NumberDisplay from "./NumberDisplay";
import { FontIcon } from "react-md";

import { LinearProgress } from "react-md";

//Import styling
import "../../styles/NumberWidget.css";

import { CircleSpinner } from "react-spinners-kit";

class NumberWidget extends Component {
  // Decide whether to show widget
  showWidget() {
    // Show loading indicator while initial data is being fetched
    if (this.props.value === undefined) {
      return (
        <p className="spinner">
          <CircleSpinner size={50} color="#2196F3" loading={true} />
        </p>
      );
    }
    if (this.props.icon) {
      let color = this.props.value === "ON" ? "#4CAF50" : "#F44336";
      return (
        <div className="NumberWidget">
          <NumberDisplay
            style={{ color: color }}
            sub={this.props.sub}
            value={
              <FontIcon
                style={{
                  color: color,
                  fontSize: "inherit",
                  margin: "5px",
                  display: "flex"
                }}
              >
                {this.props.value === "ON" ? "check_circle" : "error"}
              </FontIcon>
            }
          />
          {/* Conditionally show the progress bar */}
          {this.showProgress()}
        </div>
      );
    }
    return (
      <div className="NumberWidget">
        <NumberDisplay sub={this.props.sub} value={this.props.value} />
        {/* Conditionally show the progress bar */}
        {this.showProgress()}
      </div>
    );
  }

  // Decide whether to show a progress bar
  showProgress() {
    // Only show if the required min, max and value props are supplied
    if (this.props.sub !== undefined && this.props.value !== undefined) {
      return (
        <LinearProgress
          style={{
          boxShadow:
            'inset 0 0 0px #2196F1, inset 0px 0 0px #2196f3, inset 0px 0 0px #2196f3, inset 0px 0 0px #122d42, inset 0px 0 0px #2196F3, 0 0 5px #2196F1, 5px 0 30px #2196f3, 0px 0 1px #2196F3',
            height: "4px", 
            borderRadius: "5px" 
          }}
          query={this.props.value === "ON" ? true : false}
          value={
            this.props.value === "ON"
              ? false
              : (this.props.value / this.props.sub) * 100
          }
        />
      );
    }

    return null;
  }

  render() {
    return (
      // Wrap the number display component in the generic wrapper
      <Widget
        heading={this.props.heading}
        colspan={this.props.colspan}
        rowspan={this.props.rowspan}
        loading={this.props.loading}
        stats={this.props.stats}
      >
        {this.showWidget()}
      </Widget>
    );
  }
}

// Enforce the type of props to send to this component
NumberWidget.propTypes = {
  heading: PropTypes.string,
  colspan: PropTypes.number,
  rowspan: PropTypes.number,
  loading: PropTypes.bool.isRequired
  //min: PropTypes.number,
  //max: PropTypes.number,
  //value: PropTypes.number
};

export default NumberWidget;
